import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@mui/material'
import { useMemo } from 'react'
import { CommitIntent } from '../../../api/DTOtemp'
import { WriteWorkflowTaskModel } from '../../../api/clients/workflowTasks/DTOs'
import { SessionService } from '../../../services/session'
import {
	IInteractiveWorkflowTask,
	IInteractiveWorkflowTaskProps,
	InteractiveWorkflowTaskState,
} from './IInteractiveWorkflowTask'

type FinishPackageSubmissionInteractiveTask =
	InteractiveWorkflowTaskState<FinishPackageSubmissionInteractiveData>

type FinishPackageSubmissionInteractiveData = {
	intent: CommitIntent
}

export const FinishPackageSubmissionInteractiveTaskId =
	'FinishFormPackageSubmission'

const FinishPackageSubmissionInteraction = (
	props: IInteractiveWorkflowTaskProps<
		WriteWorkflowTaskModel<FinishPackageSubmissionInteractiveTask>
	>,
) => {
	const signalTypeId = 'FormPackageFinished'
	const sessionService = SessionService.getInstance()

	const commitIntentText = useMemo(() => {
		const intent = props.task.workflowTaskState.interactionData.intent

		if (intent === CommitIntent.Submit) return 'Submit'

		if (intent === CommitIntent.Approve) return 'Approve'

		if (intent === CommitIntent.Reject) return 'Reject'
		else throw new Error(`unsupported commit type: '${intent}'`)
	}, [props.task.workflowTaskState.interactionData.intent])

	const handleCancel = () =>
		props.onCancel({
			result: 'cancel',
			signalTypeId: signalTypeId,
			resources: [
				{
					type: 'FormPackage',
					value: props.task.workflowTaskState.resourceId,
				},
				{
					type: 'WorkflowTask',
					value: {
						id: props.task.id,
						lockPassword: props.task.lockPassword,
						outcome: 'Cancel',
						userId: sessionService.userId,
					},
				},
			],
		})

	const onConfirm = () =>
		props.onConfirm({
			result: 'okay',
			signalTypeId: signalTypeId,
			resources: [
				{
					type: 'FormPackage',
					value: props.task.workflowTaskState.resourceId,
				},
				{
					type: 'WorkflowTask',
					value: {
						id: props.task.id,
						lockPassword: props.task.lockPassword,
						outcome: 'Confirm',
						userId: sessionService.userId,
					},
				},
			],
		})

	return (
		<Dialog open={true} fullWidth>
			<DialogTitle>{commitIntentText} Form Package</DialogTitle>
			<DialogContent>
				Please confirm that you are ready to {commitIntentText.toLowerCase()}{' '}
				the form package.
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={handleCancel}>
					Cancel
				</Button>
				<Button variant="contained" onClick={onConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export const FinishPackageSubmissionInteractiveTaskDefinition: IInteractiveWorkflowTask<
	WriteWorkflowTaskModel<FinishPackageSubmissionInteractiveTask>
> = {
	id: FinishPackageSubmissionInteractiveTaskId,
	interaction: FinishPackageSubmissionInteraction,
}
